<template>
  <section class="slider-photo">
    <b-container fluid>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <carousel class="carousel-container"
                    :autoplay="true"
                    :autoplayHoverPause="true"
                    :items="6"
                    :loop="true"
                    :nav="false"
                    :dots="false"
                    :margin="40"
                    :responsive="{320: { items: 2 }, 560: { items: 3 }, 991: { items: 4 }, 1439: { items: 8 }, 2560: { items: 12 } }">
            <div v-for="(slide, index) in slides" :key="slide.id" class="slider-content-container" :class="{ 'with-margin': index % 2 === 1 }">
              <img class="slider-img" :src="slide.imageUrl" :alt="'Slide ' + slide.id">
            </div>
          </carousel>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Carousel from 'vue-owl-carousel'
export default {
  components: {
    Carousel
  },
  data () {
    return {
      slides: [
        {
          id: 1,
          imageUrl: require('@/assets/img/new-content/slider-people-1.png')
        },
        {
          id: 2,
          imageUrl: require('@/assets/img/new-content/slider-people-2.png')
        },
        {
          id: 3,
          imageUrl: require('@/assets/img/new-content/slider-people-3.png')
        },
        {
          id: 4,
          imageUrl: require('@/assets/img/new-content/slider-people-4.png')
        },
        {
          id: 5,
          imageUrl: require('@/assets/img/new-content/slider-people-5.png')
        },
        {
          id: 6,
          imageUrl: require('@/assets/img/new-content/slider-people-6.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.slider-photo{
  background-image: url('../assets/img/new-content/slider-bg.svg');
  background-position: bottom center;
  background-size: 767px;
  background-repeat: no-repeat;
  @media screen and (min-width: 320px) {
    background-size: 420px;
  }
  @media screen and (min-width: 768px) {
    background-size: 620px;
  }
  @media screen and (min-width: 992px) {
    background-size: 690px;
  }
  @media screen and (min-width: 1441px) {
    background-size: 700px;
  }
  @media screen and (min-width: 1920px) {
    background-size: 1100px;
  }
  @media screen and (min-width: 2560px) {
    background-size: 720px;
  }
}
.carousel-container{
  margin-bottom: 80px;
}
.slider-content-container.with-margin {
  margin-top: 40px;
}
.slider-content-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .slider-img{
    max-width: 508px;
    width: 100%;
    height: auto;
    @media screen and (min-width: 320px) {
      max-width: 152px ;
    }
    @media screen and (min-width: 768px) {
      max-width: 240px;
    }
    @media screen and (min-width: 992px) {
      max-width: 340px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .slider-content{
    display: flex;
    max-width: 240px;
    width: 100%;
    padding: 40px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    @media screen and (min-width: 320px) {
      max-width: 165px ;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      max-width: 240px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
}
</style>
